import { useTranslation } from 'react-i18next';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { IllustrationCardAlert } from '@/common/components/Illustrations/IllustrationCardAlert';
import { ROUTES } from '@/common/constants/routes';
import { usePathname } from 'expo-router';

type TCardExpirationBannerProps = {
  isExpired: boolean;
  isDigitalRequestFormatRenewal: boolean;
};

export const CardExpirationBanner = ({
  isExpired,
  isDigitalRequestFormatRenewal,
}: TCardExpirationBannerProps) => {
  const { t } = useTranslation();
  const pathname = usePathname();

  return (
    <CardActionLink
      title={isExpired ? t('card.expired.title') : t('card.expiring.title')}
      description={
        isExpired
          ? t('card.expired.description')
          : t('card.expiring.description')
      }
      illustration={{
        asset: <IllustrationCardAlert height={100} width={100} />,
      }}
      backgroundColor={'accentSecondary20'}
      href={{
        pathname: isDigitalRequestFormatRenewal
          ? ROUTES.CARD_EXPIRING
          : ROUTES.CARD_REQUEST,
        params: { origin: pathname },
      }}
      size="md"
    />
  );
};
